import { render } from "./AppNavigationDevicesItem.vue?vue&type=template&id=2142b9fe&scoped=true"
import script from "./AppNavigationDevicesItem.vue?vue&type=script&lang=js"
export * from "./AppNavigationDevicesItem.vue?vue&type=script&lang=js"

import "./AppNavigationDevicesItem.vue?vue&type=style&index=0&id=2142b9fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2142b9fe"]])

export default __exports__